import React from 'react';

const Footer: React.FC = () => (
  <footer className="bg-[#001f5b] border-t-2 border-[#FFB81C] py-7 px-6">
    <div className="max-w-6xl mx-auto text-center">
      <p className="text-sm text-white/60">
        © {new Date().getFullYear()} Pavements at Pitt · University of Pittsburgh
      </p>
    </div>
  </footer>
);

export default Footer;